<div [class.readonly]="readonly" [class.disabled]="control.disabled">
  <label *ngIf="label" [for]="id"
    >{{ label }}
    <app-dc-popover
      *ngIf="helpText"
      [body]="helpText"
      [class.helpText]="helpText"
    ></app-dc-popover
  ></label>
  <div class="d-flex flex-row position-relative">
    <input
      [formControl]="control"
      type="text"
      [class]="'form-control input' + ' ' + (darkMode === true ? 'dark' : '')"
      [readonly]="readonly"
      [placeholder]="placeholder == undefined ? '' : placeholder"
      autocomplete="new-input"
      [id]="id"
      [maxlength]="maxLength"
      [title]="control.value"
      [value]="control.value | roundAndFormat"
      (keydown)="onKeyDown($event)"
      (input)="onInputChange($event.target.value)"
    />
    <app-dc-control-validation
      *ngIf="control.touched"
      [status]="getValidationStatus()"
      class="{{
        control.hasError('required') && control.touched ? 'required' : ''
      }}"
      body="{{ customErrorMessage ? customErrorMessage + '.' + '<br/>' : '' }}{{
        control.hasError('required') ? 'Required field' + '.' + '<br/>' : ''
      }}{{ control.hasError('incorrect') ? control.errors.message + '.' : '' }}"
    ></app-dc-control-validation>
    <app-dc-spinner *ngIf="loading"></app-dc-spinner>
  </div>
</div>
